import { cn as e } from "../../design/cn.js";
// src/components/data-table/styles.ts
var t = () => "w-full overflow-x-hidden border-collapse border-spacing-0", n = (t, n) => e("relative", n && {
	default: "bg-card [&_th]:border-b [&_th]:border-border",
	bordered: "border-b !border-border",
	borderless: "",
	numericCompact: "bg-muted"
}[t]), r = (t) => {
	let { size: n, variant: r, sortable: i, sticky: a, scrolled: o } = t, s = {
		sm: "h-9 py-1.5 px-3.5",
		md: "h-10 py-2 px-3.5"
	}, c = {
		default: "",
		bordered: "border-r border-border last:border-r-0",
		borderless: "",
		numericCompact: "px-1.5 py-2 bg-muted border-y border-r border-border last:border-r-0 first:rounded-tl"
	}, l = i ? "cursor-pointer hover:text-foreground" : "";
	return e("relative text-left text-xs font-medium text-muted-foreground outline-none select-none transition-colors duration-150", s[n], c[r], l, a && {
		none: "",
		left: "sticky left-0 z-20 bg-card",
		right: "sticky right-0 z-20 bg-card"
	}[a], o && {
		none: "",
		left: "border-r-2 border-r-neutral-400",
		right: "border-l-2 border-l-neutral-400"
	}[o]);
}, i = (t) => {
	let { variant: n, hover: r, selected: i, clickable: a } = t, o = {
		default: "[&>td]:after:absolute [&>td]:after:inset-x-0 [&>td]:after:bottom-0 [&>td]:after:h-px [&>td]:after:w-full [&>td]:after:bg-border last:[&>td]:after:hidden",
		bordered: "[&>td]:border-b [&>td]:border-border last:[&>td]:border-b-0",
		borderless: "",
		numericCompact: "[&>td]:border-b [&>td]:border-border last:[&>td]:border-b-0"
	}, s = r ? "hover:bg-muted" : "", c = i ? "bg-primary/10 hover:bg-primary/20" : "", l = a ? "cursor-pointer" : "";
	return e("relative outline-none transition-all duration-150 ease-in-out group", o[n], s, c, l);
}, a = (t) => {
	let { size: n, variant: r, sticky: i, scrolled: a } = t;
	return e("relative text-foreground outline-none transition-colors duration-150", {
		sm: "py-1.5 px-3.5 text-sm",
		md: "py-[11px] px-3.5 text-sm"
	}[n], {
		default: "",
		bordered: "border-r border-border last:border-r-0",
		borderless: "",
		numericCompact: "px-1 py-1 text-xs border-y border-r border-border last:border-r-0"
	}[r], i && {
		none: "",
		left: "sticky left-0 z-10 bg-card",
		right: "sticky right-0 z-10 bg-card"
	}[i], a && {
		none: "",
		left: "border-r-2 border-r-neutral-400",
		right: "border-l-2 border-l-neutral-400"
	}[a]);
}, o = () => "h-4 w-4 rounded border-border bg-card text-primary shadow-sm focus:border-primary focus:ring-2 focus:ring-primary focus:ring-offset-0 disabled:cursor-not-allowed disabled:text-muted-foreground";
export { o as getCheckboxStyles, a as getTableCellStyles, r as getTableHeadStyles, n as getTableHeaderStyles, t as getTableRootStyles, i as getTableRowStyles };

//# sourceMappingURL=styles.js.map